import React from 'react';
import { Input } from '../../../components/ui/Input';
import Btn from '../../../components/ui/Btn';
import Secao from '../../../components/ui/Secao';

function elegivelSalarioFamilia(dataNascimento) {
  if (!dataNascimento) return false;
  const idade = (Date.now() - new Date(dataNascimento).getTime()) / (365.25 * 24 * 60 * 60 * 1000);
  return idade < 14;
}

export default function DependentesTab({ itens, onChange }) {
  const adicionar = () => onChange([...itens, { nome: '', cpf: '', data_nascimento: '' }]);
  const remover = (idx) => onChange(itens.filter((_, i) => i !== idx));
  const atualizar = (idx, campo, valor) => onChange(itens.map((item, i) => i === idx ? { ...item, [campo]: valor } : item));

  const elegiveis = itens.filter(i => elegivelSalarioFamilia(i.data_nascimento)).length;

  return (
    <Secao titulo="Dependentes (Filhos)">
      <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
        {itens.map((d, idx) => (
          <div key={idx} style={{ display: 'grid', gridTemplateColumns: '1.5fr 1fr 1fr auto', gap: 10, alignItems: 'end' }}>
            <Input label="Nome" value={d.nome} onChange={e => atualizar(idx, 'nome', e.target.value)} />
            <Input label="CPF" value={d.cpf} onChange={e => atualizar(idx, 'cpf', e.target.value)} />
            <Input label="Data de Nascimento" type="date" value={d.data_nascimento ? d.data_nascimento.slice(0, 10) : ''} onChange={e => atualizar(idx, 'data_nascimento', e.target.value)} />
            <Btn variante="danger" tamanho="sm" onClick={() => remover(idx)}>Remover</Btn>
          </div>
        ))}
      </div>
      <Btn variante="secondary" onClick={adicionar} style={{ marginTop: 14 }}>+ Adicionar Dependente</Btn>
      {itens.length > 0 && (
        <p style={{ fontSize: 12, color: '#64748B', marginTop: 10 }}>
          {elegiveis} dependente(s) elegível(is) ao salário-família (menores de 14 anos).
        </p>
      )}
    </Secao>
  );
}
